import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import { AGENT_CONTEXTS } from "../apps";
import { resolveContext } from "../contexts/registry";
import type { AgentState } from "../store/agentSlice";

/**
 * What the thread's context is called ("Example Coffee LLC"), from that context type's `label`
 * query (the page's own cached query); null for a general chat or while it loads.
 */
export function useContextLabel(threadId: number | null): string | null {
  const contextRef = useSelector((state: { agent: AgentState }) =>
    threadId == null ? null : (state.agent.threads[threadId]?.contextRef ?? null)
  );
  const context = resolveContext(AGENT_CONTEXTS, contextRef);
  const query = context?.def.label?.(context.id) ?? null;
  const { data } = useQuery({
    queryKey: query?.queryKey ?? ["agentNoContextLabel"],
    queryFn: query?.queryFn ?? (async () => null),
    select: query?.select ?? (() => null),
    staleTime: query?.staleTime,
    enabled: !!query,
  });
  return data || null;
}
